import React from 'react';
import { default as ReactSelect } from 'react-select';

export function Select({ options, value, onChange, disabled }) {
	return (
		<ReactSelect
			options={options}
			value={value}
			onChange={onChange}
			components={{ IndicatorSeparator:() => null }}
			isDisabled={disabled}
			styles={{
				control: (base, state) => ({
					...base,
					border: '1px solid #ced0da',
					boxShadow: 'none',
					borderRadius: '5px',
					'&:hover': {
						border: '1px solid #ced0da',
					},
					// Hacks to match input group styling for now
					marginTop: '0.9em',
					height: '48px',
					width: '100%',
					maxWidth: '45rem'
				}),
				singleValue: (base, state) => ({
					...base,
					marginBottom: '10px'
				}),
				indicatorsContainer: (base, state) => ({
					...base,
					marginBottom: '10px'
				})
			}}
		/>
	)
}
